import PayPalProp, { propTypes } from './paypalProp';

const shippingAddressProp = new PayPalProp({
  name: 'shippingAddress',
  paypalName: 'shipping_address',
  type: Object,
  injection: propTypes.TRANSACTION,
});

const props = [
  // Button Props
  new PayPalProp({ name: 'buttonStyle', paypalName: 'style', injection: propTypes.BUTTON }),
  // new PayPalProp({ name: 'braintree', injection: propTypes.BUTTON }),
  new PayPalProp({ name: 'locale', type: String, injection: propTypes.BUTTON }),

  // Transaction Props
  new PayPalProp({
    name: 'invoiceNumber',
    paypalName: 'invoice_number',
    type: String,
    injection: propTypes.TRANSACTION,
  }),
  shippingAddressProp,
];

function vmProps() {
  const vm = {};

  props.forEach((prop) => {
    vm[prop.name] = prop.getVmProp();
  });

  return vm;
}

function getTypedProps(type) {
  return props.filter(prop => prop.injection === type);
}

export default {
  vmProps,
  getTypedProps,
};



// WEBPACK FOOTER //
// ./src/utils/paypalAdditionalProps.js